import React from 'react'
import '../style/components/pagination.css'

const Pagination = ({
    currentPage,
    totalPages,
    totalItems,
    startItem,
    endItem,
    hasNextPage,
    hasPrevPage,
    onPageChange,
    isLoading
}) => {
    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;

        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        return pages;
    };

    if (isLoading) {
        return (
            <div className="pagination-container">
                <div className="pagination-loading">
                    Cargando páginas...
                </div>
            </div>
        );
    }

    return (
        <div className='pagination-container'>
            <div className="pagination-info">
                Mostrando {startItem} a {endItem} de {totalItems} resultados.
            </div>

            <div className="pagination-controls">
                <button
                    onClick={() => onPageChange(1)}
                    disabled={!hasPrevPage}
                    className="pagination-btn"
                >
                    &laquo;
                </button>

                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={!hasPrevPage}
                    className="pagination-btn"
                >
                    &#8249;
                </button>

                {getPageNumbers().map(pageNum => (
                    <button
                        key={pageNum}
                        onClick={() => onPageChange(pageNum)}
                        className={`pagination-btn ${currentPage === pageNum ? 'active' : ''}`}
                    >
                        {pageNum}
                    </button>
                ))}

                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={!hasNextPage}
                    className='pagination-btn'
                >
                    &#8250;
                </button>

                <button
                    onClick={() => onPageChange(totalPages)}
                    disabled={!hasNextPage}
                    className="pagination-btn"
                >
                    &raquo;
                </button>
            </div>
        </div>
    );
};

export default Pagination;